(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dermabella-bundle-selector-zero"]) return;
  try {
    
  if (!customElements.get('dermabella-bundle-selector-zero')) {
    class DermabellaBundleSelectorZero extends HTMLElement {
      connectedCallback() {
        this.selectedId = null;
        this.selectedIndex = 1;
        this.galleryIndex = 0;

        // ---------- Innesto tracciamento (unica aggiunta al clone) ----------
        // Il braccio NON serve qui per gli eventi: push() di db-exp-track.js
        // scrive da se' `arm: exp.arm` nel record, letto dall'assegnazione di
        // db-exp-assign.liquid. La sezione deve solo dire CHI ha emesso l'evento.
        this.sectionId = this.dataset.sectionId;
        this.track = (ev, payload) => window.DbTrack?.push(ev, payload, this.sectionId);

        this.btn = this.querySelector('[data-atc]');
        this.priceEl = this.querySelector('[data-atc-price]');
        this.labelEl = this.querySelector('[data-atc-label]');
        this.statusEl = this.querySelector('[data-atc-status]');

        // ---------- Braccio attivo (multi-offerta, 16/09/2026) ----------
        // Il markup contiene le card di OGNI lettera del registro, una .dbz-arm
        // per lettera; il CSS mostra solo quella dell'html[data-db-arm] scritto
        // da db-exp-assign.liquid (senza JS: la prima, data-db-exp-control).
        // Selezione, prezzo e imbuto devono guardare le card che il visitatore
        // vede, non quelle nascoste di un altro braccio — altrimenti si
        // aggiungerebbe al carrello la variante di un'offerta mai mostrata.
        this.#scopeToArm();
        this.#bindRadios();

        this.#initOptions();

        document.addEventListener('db-exp:rebound', () => {
          // Carrello di un altro braccio: db-exp-assign ha gia' riscritto
          // html[data-db-arm] e il CSS mostra l'altra .dbz-arm; qui si
          // ripuntano card, selezione e osservatore dell'imbuto.
          const prima = this.armRoot;
          this.#scopeToArm();
          if (this.armRoot === prima) return;
          this.selectedId = null;
          this.#initOptions();
          this.#observeOffer();
        });
        this.#initGallery();
        this.#initFaq();

        if (this.btn) {
          this.btn.addEventListener('click', () => this.#addToCart(false));
        }

        this.stickyBar = this.querySelector('[data-sticky-bar]');
        this.stickyAtc = this.querySelector('[data-sticky-atc]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.stickyText = this.querySelector('[data-sticky-text]');
        this.stickyLabel = this.querySelector('[data-sticky-label]');
        if (this.stickyAtc) {
          this.stickyAtc.addEventListener('click', () => {
            this.track('sticky_click');
            this.#addToCart(true);
          });
        }
        this.#initSticky();
        this.#initFunnelTracking();
      }

      // ---------- Imbuto di pagina (offer_view / dwell / scroll / sticky) ----------
      // Dedup per PAGINA, non per istanza: rispondono alla domanda «il
      // visitatore ha visto UN'offerta», e due istanze della sezione non
      // devono contarla due volte (stessa disciplina della sezione
      // principale). L'observer guarda il BLOCCO OPZIONI, non la sezione
      // intera: su mobile la sezione (galleria+FAQ+garanzia) e' piu' alta
      // del viewport e il 50% non arriverebbe mai — offer_view mai emesso,
      // denominatore dell'ATC rate rotto.
      #initFunnelTracking() {
        const stato = (window.__dbZeroFunnel = window.__dbZeroFunnel || {
          offerView: false, offerDwell: false, scroll: {}, stickyView: false
        });
        let dentroDa = null;
        let dwellTimer = null;
        this.offerObserver = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          if (entry.isIntersecting) {
            if (dentroDa === null) dentroDa = Date.now();
            if (!stato.offerView && !this.viewTimer) {
              this.viewTimer = setTimeout(() => {
                if (dentroDa !== null && !stato.offerView) {
                  stato.offerView = true;
                  this.track('offer_view');
                }
              }, 1000);
            }
            if (!stato.offerDwell && !dwellTimer) {
              dwellTimer = setTimeout(() => {
                if (dentroDa !== null && !stato.offerDwell) {
                  stato.offerDwell = true;
                  this.track('offer_dwell');
                }
              }, 10000);
            }
          } else {
            dentroDa = null;
            if (this.viewTimer) { clearTimeout(this.viewTimer); this.viewTimer = null; }
            if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
          }
        }, { threshold: 0.5 });
        this.#observeOffer();

        const profondita = [25, 50, 75, 100];
        const misuraScroll = () => {
          const doc = document.documentElement;
          const massimo = doc.scrollHeight - window.innerHeight;
          if (massimo <= 0) return;
          const quota = Math.round((window.scrollY / massimo) * 100);
          for (const soglia of profondita) {
            if (quota >= soglia && !stato.scroll[soglia]) {
              stato.scroll[soglia] = true;
              this.track('scroll', { depth: soglia });
            }
          }
        };
        window.addEventListener('scroll', misuraScroll, { passive: true });
        misuraScroll();
      }

      // Attesa del braccio risolto prima dell'ATC: la verifica «il carrello
      // vince sul cookie» di db-exp-assign.liquid e' asincrona, e aggiungere
      // al carrello mentre e' in volo rischia un carrello misto. Tetto di
      // 2000ms: bloccare un acquisto e' peggio di un raro carrello misto.
      #waitForArmResolution() {
        return new Promise((resolve) => {
          const exp = window.DbExp;
          if (!exp || exp.resolved !== false) { resolve(); return; }
          let concluso = false;
          const chiudi = () => {
            if (concluso) return;
            concluso = true;
            document.removeEventListener('db-exp:resolved', chiudi);
            resolve();
          };
          document.addEventListener('db-exp:resolved', chiudi, { once: true });
          setTimeout(chiudi, 2000);
        });
      }

      #initSticky() {
        if (!this.stickyBar || !this.btn) return;
        // Mostra la barra solo dopo che l'ATC principale è stato superato scrollando
        // (non quando semplicemente non è stato ancora raggiunto, cioè è sotto il
        // viewport prima dello scroll iniziale). boundingClientRect.top < 0 indica
        // che il bottone principale è sopra il viewport, cioè "già superato".
        const io = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          const pastMain = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.stickyBar.hidden = !pastMain;
          this.stickyBar.setAttribute('aria-hidden', pastMain ? 'false' : 'true');
          // toggle su rAF così la transizione parte dopo la rimozione di [hidden]
          requestAnimationFrame(() => this.stickyBar.toggleAttribute('data-visible', pastMain));
          const statoFunnel = window.__dbZeroFunnel;
          if (pastMain && statoFunnel && !statoFunnel.stickyView) {
            statoFunnel.stickyView = true;
            this.track('sticky_view');
          }
        }, { threshold: 0 });
        io.observe(this.btn);
      }

      // Il contenitore del braccio assegnato; se manca (lettera del registro
      // senza card su questo prodotto, o assegnazione non ancora avvenuta), la
      // lettera di controllo — la stessa che il CSS mostra senza data-db-arm.
      #armRoot() {
        const arm = document.documentElement.dataset.dbArm;
        return (arm && this.querySelector(`.dbz-arm[data-db-arm="${arm}"]`)) ||
          this.querySelector('.dbz-arm[data-db-exp-control]') ||
          this;
      }

      #scopeToArm() {
        this.armRoot = this.#armRoot();
        this.options = Array.from(this.armRoot.querySelectorAll('[data-option]'));
      }

      // I listener sui radio si agganciano UNA volta, su tutte le card di tutti
      // i bracci: un rebound avanti e indietro non deve raddoppiare i
      // tier_select. Una card nascosta non e' cliccabile, quindi non parla.
      #bindRadios() {
        this.querySelectorAll('[data-option]').forEach((opt) => {
          const radio = opt.querySelector('[data-variant-radio]');
          if (!radio) return;
          radio.addEventListener('change', () => {
            if (radio.checked) this.#selectOption(opt, true);
          });
        });
      }

      // L'osservatore dell'imbuto guarda il blocco opzioni del braccio ATTIVO:
      // un nodo nascosto (display:none) non interseca mai, quindi dopo un
      // rebound va ripuntato, o offer_view/offer_dwell non arriverebbero piu'.
      #observeOffer() {
        if (!this.offerObserver) return;
        if (this.offerTarget) this.offerObserver.unobserve(this.offerTarget);
        this.offerTarget = (this.armRoot && this.armRoot.querySelector('[data-options]')) || this;
        this.offerObserver.observe(this.offerTarget);
      }

      #initOptions() {
        this.options.forEach((opt) => {
          const radio = opt.querySelector('[data-variant-radio]');
          if (radio && radio.checked) this.#selectOption(opt);
        });
        // Fallback: nothing pre-checked (e.g. all sold out) -> pick first available.
        if (!this.selectedId) {
          const firstAvail = this.options.find((o) => o.dataset.available === 'true');
          if (firstAvail) {
            const r = firstAvail.querySelector('[data-variant-radio]');
            if (r) { r.checked = true; }
            this.#selectOption(firstAvail);
          }
        }
      }

      #selectOption(opt, fromUser = false) {
        this.selectedId = opt.dataset.variantId || null;
        // Solo i click veri: la preselezione al caricamento non e' una
        // scelta del visitatore, e contarla gonfierebbe i tier_select.
        if (fromUser) this.track('tier_select', { variant_id: this.selectedId, sku: opt.dataset.sku || null });
        this.selectedIndex = parseInt(opt.dataset.index, 10) || 1;
        const available = opt.dataset.available === 'true';

        if (this.priceEl && opt.dataset.price) this.priceEl.textContent = opt.dataset.price;
        if (this.stickyPrice && opt.dataset.price) this.stickyPrice.textContent = opt.dataset.price;
        // La barra sticky mostra a sinistra il nome del formato scelto (non un doppione del bottone).
        if (this.stickyLabel) {
          const fmt = opt.querySelector('.dbz-option__label');
          if (fmt) this.stickyLabel.textContent = fmt.textContent.trim();
        }

        if (this.btn) {
          if (available) {
            this.btn.disabled = false;
            this.btn.removeAttribute('aria-disabled');
            if (this.labelEl) this.labelEl.textContent = this.btn.dataset.labelText || this.labelEl.textContent;
          } else {
            this.btn.disabled = true;
            this.btn.setAttribute('aria-disabled', 'true');
            if (this.labelEl) this.labelEl.textContent = 'Non disponibile';
          }
        }

        if (this.stickyAtc) {
          if (available) {
            this.stickyAtc.disabled = false;
            this.stickyAtc.removeAttribute('aria-disabled');
            if (this.stickyText) this.stickyText.textContent = this.stickyAtc.dataset.labelText || this.stickyText.textContent;
          } else {
            this.stickyAtc.disabled = true;
            this.stickyAtc.setAttribute('aria-disabled', 'true');
            if (this.stickyText) this.stickyText.textContent = 'Non disponibile';
          }
        }
      }

      /* ---------------- Galleria ---------------- */
      #initGallery() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        if (this.slides.length < 2) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.track('gallery_nav');
            this.#showSlide(parseInt(thumb.dataset.index, 10) || 0);
          });
        });
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.#step(-1));
        if (next) next.addEventListener('click', () => this.#step(1));

        // Frecce della striscia miniature: scorrono la lista orizzontalmente.
        this.thumbStrip = this.querySelector('[data-thumbs]');
        this.thumbPrev = this.querySelector('[data-thumb-prev]');
        this.thumbNext = this.querySelector('[data-thumb-next]');
        if (this.thumbStrip) {
          const stepPx = () => {
            const first = this.thumbStrip.querySelector('.dbz-gallery__thumb');
            return first ? (first.offsetWidth + 8) * 2 : 160;
          };
          if (this.thumbPrev) {
            this.thumbPrev.addEventListener('click', () => {
              this.thumbStrip.scrollBy({ left: -stepPx(), behavior: 'smooth' });
            });
          }
          if (this.thumbNext) {
            this.thumbNext.addEventListener('click', () => {
              this.thumbStrip.scrollBy({ left: stepPx(), behavior: 'smooth' });
            });
          }
          this.thumbStrip.addEventListener('scroll', () => this.#updateThumbNav(), { passive: true });
          window.addEventListener('resize', () => this.#updateThumbNav());
          this.#updateThumbNav();
        }
      }

      #updateThumbNav() {
        if (!this.thumbStrip) return;
        const max = this.thumbStrip.scrollWidth - this.thumbStrip.clientWidth;
        const x = this.thumbStrip.scrollLeft;
        const overflowing = max > 2;
        const wrap = this.thumbStrip.closest('.dbz-gallery__thumbwrap');
        if (wrap) wrap.classList.toggle('is-static', !overflowing);
        if (this.thumbPrev) this.thumbPrev.disabled = !overflowing || x <= 1;
        if (this.thumbNext) this.thumbNext.disabled = !overflowing || x >= max - 1;
      }

      #step(dir) {
        const total = this.slides.length;
        this.#showSlide((this.galleryIndex + dir + total) % total);
      }

      #showSlide(index) {
        this.galleryIndex = index;
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) { slide.removeAttribute('aria-hidden'); }
          else { slide.setAttribute('aria-hidden', 'true'); }
        });
        this.thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
            if (this.thumbStrip) {
              const li = thumb.closest('li') || thumb;
              this.thumbStrip.scrollTo({
                left: li.offsetLeft - (this.thumbStrip.clientWidth - li.offsetWidth) / 2,
                behavior: 'smooth',
              });
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      /* ---------------- FAQ (accordion single-open) ---------------- */
      #initFaq() {
        const rows = Array.from(this.querySelectorAll('.dbz-faq__row'));
        if (rows.length < 2) return;
        rows.forEach((row) => {
          row.addEventListener('toggle', () => {
            if (!row.open) return;
            this.track('faq_open');
            rows.forEach((other) => {
              if (other !== row && other.open) other.open = false;
            });
          });
        });
      }

      /* ---------------- Add to cart ---------------- */
      async #addToCart(fromSticky = false) {
        if (!this.selectedId || (this.btn && this.btn.disabled)) return;
        const variantId = this.selectedId;

        this.#setLoading(true);
        this.#status('', null);

        // Gate del braccio (dalla sezione principale): se la verifica
        // asincrona carrello-vs-cookie e' ancora in volo, si aspetta (tetto
        // 2000ms) prima di toccare il carrello. Poi si RIVALIDA la
        // selezione: nulla da cambiare su questa pagina (il braccio e'
        // legato), ma la disciplina resta identica.
        const exp = window.DbExp;
        if (exp && exp.status === 'running' && exp.resolved === false) {
          await this.#waitForArmResolution();
        }

        this.track('atc_click', { variant_id: variantId, source: fromSticky ? 'sticky' : 'main' });
        // atc_result UNA volta sola, qualunque strada prenda la richiesta
        // (ok, errore HTTP, eccezione): senza la guardia, un fallimento che
        // attraversa piu' rami lo conterebbe due volte.
        let atcResultTracked = false;
        const trackAtcResult = (ok) => {
          if (atcResultTracked) return;
          atcResultTracked = true;
          this.track('atc_result', { ok });
        };

        let CartLinesUpdateEvent = null;
        let deferred = null;
        try {
          const mod = await import('@shopify/events');
          if (mod && mod.CartLinesUpdateEvent) CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
        } catch (e) {
          CartLinesUpdateEvent = null;
        }

        if (CartLinesUpdateEvent) {
          try {
            deferred = CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            deferred = null;
          }
        }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          const data = await res.json().catch(() => ({}));

          trackAtcResult(res.ok);
          if (!res.ok) {
            if (deferred) { try { deferred.reject(data); } catch (e) {} }
            this.#status(data.description || data.message || 'Impossibile aggiungere al carrello. Riprova.', 'error');
            return;
          }

          // Attributi di attribuzione sul carrello — la spina dorsale che
          // lega l'ordine all'offerta e alla sessione (letti da orders.ts e
          // dal riallineamento in db-exp-assign.liquid). Solo con un test in
          // corso, in try/catch: un fallimento qui non deve mai bloccare
          // l'acquisto (resta l'attribuzione via SKU).
          try {
            if (exp && exp.status === 'running') {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  attributes: {
                    _exp_test: exp.testId,
                    _exp_arm: exp.arm,
                    _exp_uid: exp.uid,
                    _exp_sid: exp.sid
                  }
                })
              });
            }
          } catch (e) { /* attribuzione via SKU comunque intatta */ }

          // Aggiunge/riallinea i regali PRIMA di aprire il drawer, così appare già
          // completo. clearDeclined: una nuova scelta di bundle azzera i rifiuti
          // precedenti. Se il motore fallisce, l'acquisto procede comunque: la
          // protezione economica è degli sconti automatici lato server.
          try {
            await window.DermabellaGifts?.reconcile({ clearDeclined: true });
          } catch (e) { /* non bloccare l'acquisto */ }

          let nativeHandled = false;
          if (deferred && CartLinesUpdateEvent) {
            try {
              const ajaxCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                detail: {
                  items: ajaxCart.items,
                  source: 'dermabella-bundle-selector',
                  sourceId: this.dataset.sectionId || 'dermabella-bundle',
                  itemCount: 1,
                  didError: false,
                },
              });
              nativeHandled = true;
            } catch (e) {
              nativeHandled = false;
            }
          }

          if (!nativeHandled) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
            if (trigger) {
              trigger.click();
            } else {
              window.location.href = '/cart';
              return;
            }
          }

          // Apertura esplicita e idempotente del cart drawer: l'auto-open nativo
          // salta il PRIMISSIMO add di sessione (carrello vuoto, drawer mai aperto).
          try {
            const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer')
              || document.querySelector('theme-drawer[id*="cart" i], theme-drawer.cart-drawer');
            if (drawer && !drawer.hasAttribute('open') && typeof drawer.open === 'function') {
              drawer.open();
            }
          } catch (e) { /* non bloccare */ }

          this.track('cart_open');
          this.#status('Aggiunto al carrello.', 'success');
        } catch (err) {
          trackAtcResult(false);
          if (deferred) { try { deferred.reject(err); } catch (e) {} }
          this.#status('Connessione non riuscita. Riprova.', 'error');
        } finally {
          this.#setLoading(false);
        }
      }

      #setLoading(state) {
        if (!this.btn) return;
        this.btn.classList.toggle('is-loading', state);
        this.btn.disabled = state;
        this.btn.setAttribute('aria-busy', state ? 'true' : 'false');
        // Rispecchia lo stato sul bottone sticky: durante il caricamento non deve
        // sembrare cliccabile; a fine richiesta torna disabilitato solo se il
        // bottone principale lo è (es. variante esaurita), non incondizionatamente.
        if (this.stickyAtc) {
          this.stickyAtc.disabled = this.btn.disabled;
        }
      }

      #status(message, state) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        if (state) {
          this.statusEl.dataset.state = state;
          this.statusEl.classList.remove('visually-hidden');
        } else {
          delete this.statusEl.dataset.state;
          this.statusEl.classList.add('visually-hidden');
        }
      }
    }

    customElements.define('dermabella-bundle-selector-zero', DermabellaBundleSelectorZero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermabella-bundle-selector"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('dermabella-bundle-selector')) {
    // Fail-open: bloccare un acquisto è peggio di un raro carrello misto. Se
    // db-exp-assign.liquid non risolve entro questa soglia (rete lenta, endpoint
    // giù), #addToCart si sblocca comunque — mai un percorso che lo lasci in
    // attesa per sempre.
    const ARM_RESOLUTION_TIMEOUT_MS = 2000;

    // Stato condiviso fra TUTTE le istanze di questa sezione sulla stessa pagina.
    // La sezione resta inseribile ovunque e in più istanze (requisito esplicito),
    // ma offer_view/offer_dwell/scroll/sticky_view rispondono alla domanda "il
    // visitatore ha visto/scorso/soffermato UN'offerta" — un fatto di PAGINA, non
    // di istanza. Ogni istanza osserva ancora il proprio armRoot/btn (necessario:
    // sono elementi DOM fisicamente diversi), ma l'EMISSIONE di questi quattro
    // eventi è deduplicata qui, non lasciata a un contratto non scritto lato app
    // sul section_id. Dichiarato nello stesso blocco guardato da
    // customElements.get, quindi creato una sola volta quanto la classe stessa,
    // indipendentemente da quante istanze della sezione la pagina renderizzi.
    const pageFunnelState = {
      offerViewSent: false,
      dwellStart: null,
      offerDwellSent: false,
      scrollSeenDepths: new Set(),
      stickyViewSent: false,
    };

    class DermabellaBundleSelector extends HTMLElement {
      connectedCallback() {
        this.selectedId = null;
        this.selectedIndex = 1;
        this.selectedAvailable = false;
        this.galleryIndex = 0;

        // Con più bracci nel DOM, ogni query deve restare dentro il braccio attivo:
        // altrimenti il selettore raccoglie anche le opzioni nascoste degli altri.
        const arm = document.documentElement.dataset.dbArm;
        const controlRoot = this.querySelector('.db-arm[data-db-exp-control]');
        let requestedRoot = arm && this.querySelector(`.db-arm[data-db-arm="${arm}"]`);

        // Auto-difesa: se il braccio assegnato non ha nulla da mostrare IN QUESTA
        // sezione (nessun tier di QUESTO prodotto risolve a una variante reale — solo
        // qui lo si può sapere, product.variants non è leggibile né da
        // db-exp-assign.liquid né da dermabella-offers-config.liquid, che infatti
        // restano su "il primo del registro"), il gating CSS su data-db-arm non ha
        // alcun .db-arm da mostrare: la sezione resterebbe vuota. Si ricade sul
        // braccio di controllo SOLO fuori da 'running': lì non c'è nulla da
        // proteggere, ed è lo stesso guasto che c735f27 aveva già chiuso per il caso
        // draft. In 'running' NON si corregge — un ripiego silenzioso farebbe
        // comprare la variante del braccio mostrato mentre la sessione resta
        // registrata sul braccio assegnato: vendita salvata, attribuzione rotta. Un
        // braccio vuoto in running è un errore di configurazione da vedere (zero
        // ordini per quel braccio in dashboard), non da nascondere.
        if (arm && !requestedRoot && controlRoot && window.DbExp && window.DbExp.status !== 'running') {
          const controlArm = controlRoot.dataset.dbArm;
          document.documentElement.dataset.dbArm = controlArm;
          window.DbExp.arm = controlArm;
          // Best-effort: altri script (es. il motore regali) che ascoltano
          // db-exp:rebound possono non essere ancora in ascolto a questo punto
          // dell'esecuzione — nessuna garanzia d'ordine fra script diversi. Non è
          // un problema oggi (il braccio B non ha ancora omaggi), ma non costa
          // nulla dispacciarlo comunque per chi lo sente.
          document.dispatchEvent(new CustomEvent('db-exp:rebound', { detail: { arm: controlArm } }));
          requestedRoot = controlRoot;
        }

        this.armRoot = requestedRoot || controlRoot || this;

        // Istanza, non closure locale: gli hook vivono su più metodi (#selectOption,
        // #step/#showSlide, #initFaq, #addToCart...), non solo dentro connectedCallback,
        // quindi serve richiamabile via this.track(...) da ovunque. push() no-op da sé
        // se il tracker non è attivo o il consenso manca — non serve controllarlo qui.
        const sectionId = this.dataset.sectionId || '';
        this.track = (ev, payload) => window.DbTrack?.push(ev, payload, sectionId);

        this.btn = this.querySelector('[data-atc]');
        // Prezzo dell'ATC: come armRoot, ma per un attributo invece che per un sottoalbero —
        // esistono più span (uno per braccio), CSS-gated, e serve quello del braccio attivo.
        this.priceEl = this.#armScoped('data-atc-price');
        this.labelEl = this.querySelector('[data-atc-label]');
        this.statusEl = this.querySelector('[data-atc-status]');

        // Lo sticky va risolto QUI, PRIMA di #initOptions() — non spostarlo
        // più sotto (N3-bis). #initOptions() chiama #selectDefaultOption(),
        // che nel ramo "nulla di selezionabile" chiama
        // #updatePurchaseButtons(false), e quel metodo scrive lo stato
        // disabled sullo sticky solo `if (this.stickyAtc)`. Se this.stickyAtc
        // non esiste ancora, quella prima chiamata disabilita il bottone
        // principale e lascia lo sticky esattamente come il Liquid lo ha
        // renderizzato — cioè abilitato, perché il Liquid calcola
        // preselect_available sul braccio di CONTROLLO, non su quello
        // assegnato. Risultato: un bottone d'acquisto visibile, abilitato,
        // che un click non fa fare nulla — lo stesso difetto che C1 chiudeva
        // sul principale, riaperto qui sullo sticky la prima volta che questo
        // blocco è stato scritto dopo #initOptions() invece che prima.
        this.stickyBar = this.querySelector('[data-sticky-bar]');
        this.stickyAtc = this.querySelector('[data-sticky-atc]');
        this.stickyText = this.querySelector('[data-sticky-text]');
        this.stickyLabel = this.#armScoped('data-sticky-label');
        this.stickyEm = this.#armScoped('data-sticky-em');
        if (this.stickyAtc) {
          this.stickyAtc.addEventListener('click', () => {
            this.track('sticky_click');
            this.#addToCart(true);
          });
        }
        this.#initSticky();

        this.#initOptions();

        document.addEventListener('db-exp:rebound', () => {
          const rebound = document.documentElement.dataset.dbArm;
          const root = this.querySelector(`.db-arm[data-db-arm="${rebound}"]`);
          if (!root) return;
          const previousArmRoot = this.armRoot;
          this.armRoot = root;
          // Non solo il fieldset: anche il prezzo dell'ATC e le due righe della barra
          // sticky sono per-braccio, quindi vanno ripuntati sul nuovo braccio —
          // altrimenti #selectOption() continuerebbe ad aggiornare gli span nascosti del
          // vecchio braccio invece di quelli ora visibili.
          this.priceEl = this.#armScoped('data-atc-price');
          this.stickyLabel = this.#armScoped('data-sticky-label');
          this.stickyEm = this.#armScoped('data-sticky-em');
          this.#selectDefaultOption();
          // viewObserver è dichiarato più sotto in questo stesso connectedCallback,
          // non prima di questo listener — ma questa closure viene invocata solo
          // all'evento 'db-exp:rebound', sempre dopo che connectedCallback è già
          // tornato (mai in modo sincrono da questa stessa chiamata), quindi
          // viewObserver è già assegnato quando questo blocco gira davvero. Senza
          // questo ri-aggancio, il vecchio armRoot (ora display:none per il gating
          // CSS) resta l'unico elemento osservato: un nodo nascosto non interseca
          // mai, quindi offer_view/offer_dwell smettono di arrivare per ogni
          // sessione con un rebound — proprio quelle che il riallineamento doveva
          // rendere corrette, non silenziose.
          viewObserver.unobserve(previousArmRoot);
          viewObserver.observe(this.armRoot);
        });

        this.#initGallery();
        this.#initFaq();

        if (this.btn) {
          this.btn.addEventListener('click', () => this.#addToCart(false));
        }

        // offer_view è il denominatore corretto per l'ATC rate: chi rimbalza senza
        // mai raggiungere l'offerta non ha valutato nulla, e includerlo diluirebbe
        // il segnale. 50% visibile per 1s, una sola volta per PAGINA (pageFunnelState,
        // sopra) — non per istanza: con più sezioni sulla stessa pagina, ognuna
        // osserva il proprio armRoot (necessario, sono nodi diversi), ma solo la
        // prima che soddisfa la condizione emette davvero l'evento. Senza questa
        // deduplica, due istanze dimezzerebbero l'ATC rate misurato (due offer_view
        // per una sola sessione che ha visto l'offerta una volta).
        let viewTimer = null;
        const viewObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (pageFunnelState.dwellStart === null) pageFunnelState.dwellStart = Date.now();
              if (!pageFunnelState.offerViewSent && viewTimer === null) {
                viewTimer = setTimeout(() => {
                  // Ricontrollato al momento di emettere, non solo all'avvio del
                  // timer: un'altra istanza potrebbe aver già inviato l'evento nel
                  // frattempo (il proprio armRoot era già visibile da prima).
                  if (pageFunnelState.offerViewSent) return;
                  pageFunnelState.offerViewSent = true;
                  this.track('offer_view');
                }, 1000);
              }
            } else if (viewTimer !== null) {
              clearTimeout(viewTimer);
              viewTimer = null;
            }
          }
        }, { threshold: 0.5 });
        // armRoot ricade sempre almeno su `this` (mai null/falsy), quindi non serve
        // distinguere i due casi: è sempre lui l'elemento giusto da osservare.
        viewObserver.observe(this.armRoot);

        window.addEventListener('pagehide', () => {
          if (pageFunnelState.offerDwellSent) return;
          if (pageFunnelState.dwellStart !== null) {
            pageFunnelState.offerDwellSent = true;
            this.track('offer_dwell', { ms: Date.now() - pageFunnelState.dwellStart });
          }
        }, { once: true });

        const scrollDepths = [25, 50, 75, 100];
        window.addEventListener('scroll', () => {
          const height = document.documentElement.scrollHeight - window.innerHeight;
          if (height <= 0) return;
          const pct = Math.round((window.scrollY / height) * 100);
          for (const depth of scrollDepths) {
            if (pct >= depth && !pageFunnelState.scrollSeenDepths.has(depth)) {
              pageFunnelState.scrollSeenDepths.add(depth);
              this.track('scroll', { depth });
            }
          }
        }, { passive: true });
      }

      #initSticky() {
        if (!this.stickyBar || !this.btn) return;
        // Mostra la barra solo dopo che l'ATC principale è stato superato scrollando
        // (non quando semplicemente non è stato ancora raggiunto, cioè è sotto il
        // viewport prima dello scroll iniziale). boundingClientRect.top < 0 indica
        // che il bottone principale è sopra il viewport, cioè "già superato".
        // La barra sticky di QUESTA istanza va mostrata/nascosta comunque (display
        // per istanza, sono nodi diversi) — solo l'emissione di sticky_view è
        // deduplicata per pagina via pageFunnelState, stesso motivo di offer_view.
        const io = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          const pastMain = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.stickyBar.hidden = !pastMain;
          this.stickyBar.setAttribute('aria-hidden', pastMain ? 'false' : 'true');
          // toggle su rAF così la transizione parte dopo la rimozione di [hidden]
          requestAnimationFrame(() => this.stickyBar.toggleAttribute('data-visible', pastMain));
          if (pastMain && !pageFunnelState.stickyViewSent) {
            pageFunnelState.stickyViewSent = true;
            this.track('sticky_view');
          }
        }, { threshold: 0 });
        io.observe(this.btn);
      }

      // Trova, per un attributo dato (es. 'data-atc-price'), l'elemento del braccio attivo fra
      // i più che esistono (uno per braccio, CSS-gated) — stesso fallback di armRoot: braccio
      // attivo, poi il braccio di controllo, poi il primo che c'è.
      #armScoped(attr) {
        const arm = document.documentElement.dataset.dbArm;
        return (
          (arm && this.querySelector(`[${attr}][data-db-arm="${arm}"]`)) ||
          this.querySelector(`[${attr}][data-db-exp-control]`) ||
          this.querySelector(`[${attr}]`)
        );
      }

      #initOptions() {
        // I listener coprono tutti i bracci: le opzioni nascoste non sono
        // cliccabili, e così un riallineamento al braccio del carrello non
        // lascia mai opzioni senza gestore.
        this.querySelectorAll('[data-option]').forEach((opt) => {
          const radio = opt.querySelector('[data-variant-radio]');
          if (!radio) return;
          radio.addEventListener('change', () => {
            if (radio.checked) this.#selectOption(opt, true);
          });
        });
        this.#selectDefaultOption();
      }

      // La preselezione riguarda solo il braccio visibile: pescare l'opzione da
      // un braccio nascosto imposterebbe un prezzo che il visitatore non vede.
      #selectDefaultOption() {
        const scope = this.armRoot;
        const checked = scope.querySelector('[data-variant-radio]:checked');
        if (checked) { this.#selectOption(checked.closest('[data-option]')); return; }
        const firstAvail = [...scope.querySelectorAll('[data-option]')].find(
          (opt) => opt.dataset.available === 'true'
        );
        if (firstAvail) {
          const radio = firstAvail.querySelector('[data-variant-radio]');
          if (radio) radio.checked = true;
          this.#selectOption(firstAvail);
          return;
        }
        // Nessuna opzione selezionabile in questo braccio (tipicamente dopo un
        // rebound verso un braccio con tutti i tier esauriti): azzerare esplicitamente
        // invece di lasciare selectedId/selectedAvailable del braccio PRECEDENTE
        // ancora validi. #addToCart li rilegge dopo l'attesa — senza questo
        // azzeramento un rebound verso un braccio senza nulla di disponibile
        // comprerebbe comunque la variante del braccio di partenza, con l'attributo
        // carrello _exp_arm scritto sul braccio nuovo: il carrello misto che il gate
        // esiste per impedire, raggiunto perché qui la verità restava stantia, non
        // assente (il controllo `!this.selectedId` in #addToCart non intercetta un
        // valore vecchio ma ancora presente).
        this.selectedId = null;
        this.selectedAvailable = false;
        // Anche lo STATO DEL BOTTONE va aggiornato qui, non solo selectedId/
        // selectedAvailable: #selectOption lo fa sempre (via #updatePurchaseButtons,
        // sotto), questo ramo — aggiunto separatamente per I1 — non lo faceva, ed è
        // esattamente così che è nato questo stesso difetto (due punti che decidono
        // lo stato del bottone, uno dei due dimenticato). #addToCart mostra già un
        // messaggio a un click qui (C1), ma un bottone «Ordina ora» abilitato sopra
        // un braccio senza nulla da vendere resta uno stato visivamente incoerente.
        this.#updatePurchaseButtons(false);
      }

      // fromUser distingue un click reale dalla preselezione (#selectDefaultOption,
      // anche via rebound carrello): #selectOption viene chiamato in entrambi i casi, ma
      // solo il primo è un tier_select genuino — filtrare a valle sporcherebbe i dati
      // con eventi che il visitatore non ha generato.
      #selectOption(opt, fromUser = false) {
        this.selectedId = opt.dataset.variantId || null;
        this.selectedIndex = parseInt(opt.dataset.index, 10) || 1;
        const available = opt.dataset.available === 'true';
        // Segnale dedicato all'acquistabilità, separato da this.btn.disabled: quello
        // riflette anche lo stato di caricamento (#setLoading), non solo la
        // disponibilità — usarlo per entrambi i significati è ciò che rompeva
        // #addToCart dopo un'attesa (vedi lì).
        this.selectedAvailable = available;

        if (this.priceEl && opt.dataset.price) this.priceEl.textContent = opt.dataset.price;
        // La barra sticky mostra a sinistra il formato scelto su due righe (non un
        // doppione del bottone): il nome sopra, il regalo sotto. Il regalo sta in un <em>
        // dentro l'etichetta della card, quindi il nome è il testo dell'etichetta MENO
        // quello dell'em — non `textContent` intero, che li rimetterebbe su una riga.
        const fmt = opt.querySelector('.db-option__label');
        if (fmt && this.stickyLabel) {
          const em = fmt.querySelector('.db-option__label-em');
          const emTesto = em ? em.textContent.trim() : '';
          this.stickyLabel.textContent = fmt.textContent.replace(emTesto, '').trim();
          if (this.stickyEm) this.stickyEm.textContent = emTesto;
        }

        this.#updatePurchaseButtons(available);

        if (fromUser) {
          this.track('tier_select', {
            variant_id: Number(opt.dataset.variantId),
            sku: opt.dataset.sku || null,
            tier_index: Number(opt.dataset.index),
            price: opt.dataset.price || null
          });
        }
      }

      // Estratto da #selectOption: unica fonte per "come appaiono i bottoni
      // d'acquisto quando la disponibilità è X", chiamato sia da lì sia dal ramo
      // di azzeramento di #selectDefaultOption qui sopra — prima che esistesse
      // questo metodo, i due punti duplicavano la stessa logica indipendentemente,
      // ed è così che uno dei due è rimasto indietro (vedi il commento lì sopra).
      #updatePurchaseButtons(available) {
        if (this.btn) {
          if (available) {
            this.btn.disabled = false;
            this.btn.removeAttribute('aria-disabled');
            if (this.labelEl) this.labelEl.textContent = this.btn.dataset.labelText || this.labelEl.textContent;
          } else {
            this.btn.disabled = true;
            this.btn.setAttribute('aria-disabled', 'true');
            if (this.labelEl) this.labelEl.textContent = 'Non disponibile';
          }
        }

        if (this.stickyAtc) {
          if (available) {
            this.stickyAtc.disabled = false;
            this.stickyAtc.removeAttribute('aria-disabled');
            if (this.stickyText) this.stickyText.textContent = this.stickyAtc.dataset.labelText || this.stickyText.textContent;
          } else {
            this.stickyAtc.disabled = true;
            this.stickyAtc.setAttribute('aria-disabled', 'true');
            if (this.stickyText) this.stickyText.textContent = 'Non disponibile';
          }
        }
      }

      /* ---------------- Galleria ---------------- */
      #initGallery() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        if (this.slides.length < 2) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.#showSlide(parseInt(thumb.dataset.index, 10) || 0);
          });
        });
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.#step(-1));
        if (next) next.addEventListener('click', () => this.#step(1));

        // Frecce della striscia miniature: scorrono la lista orizzontalmente.
        this.thumbStrip = this.querySelector('[data-thumbs]');
        this.thumbPrev = this.querySelector('[data-thumb-prev]');
        this.thumbNext = this.querySelector('[data-thumb-next]');
        if (this.thumbStrip) {
          const stepPx = () => {
            const first = this.thumbStrip.querySelector('.db-gallery__thumb');
            return first ? (first.offsetWidth + 8) * 2 : 160;
          };
          if (this.thumbPrev) {
            this.thumbPrev.addEventListener('click', () => {
              this.thumbStrip.scrollBy({ left: -stepPx(), behavior: 'smooth' });
            });
          }
          if (this.thumbNext) {
            this.thumbNext.addEventListener('click', () => {
              this.thumbStrip.scrollBy({ left: stepPx(), behavior: 'smooth' });
            });
          }
          this.thumbStrip.addEventListener('scroll', () => this.#updateThumbNav(), { passive: true });
          window.addEventListener('resize', () => this.#updateThumbNav());
          this.#updateThumbNav();
        }
      }

      #updateThumbNav() {
        if (!this.thumbStrip) return;
        const max = this.thumbStrip.scrollWidth - this.thumbStrip.clientWidth;
        const x = this.thumbStrip.scrollLeft;
        const overflowing = max > 2;
        const wrap = this.thumbStrip.closest('.db-gallery__thumbwrap');
        if (wrap) wrap.classList.toggle('is-static', !overflowing);
        if (this.thumbPrev) this.thumbPrev.disabled = !overflowing || x <= 1;
        if (this.thumbNext) this.thumbNext.disabled = !overflowing || x >= max - 1;
      }

      #step(dir) {
        const total = this.slides.length;
        this.#showSlide((this.galleryIndex + dir + total) % total);
      }

      // Unico punto in cui l'indice della galleria cambia davvero (frecce via #step,
      // click su una miniatura direttamente): tracciare qui invece che in entrambi i
      // punti di chiamata copre entrambi senza duplicare l'evento.
      #showSlide(index) {
        this.galleryIndex = index;
        this.track('gallery_nav', { index: this.galleryIndex });
        this.slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) { slide.removeAttribute('aria-hidden'); }
          else { slide.setAttribute('aria-hidden', 'true'); }
        });
        this.thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
            if (this.thumbStrip) {
              const li = thumb.closest('li') || thumb;
              this.thumbStrip.scrollTo({
                left: li.offsetLeft - (this.thumbStrip.clientWidth - li.offsetWidth) / 2,
                behavior: 'smooth',
              });
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      /* ---------------- FAQ (accordion single-open) ---------------- */
      #initFaq() {
        const rows = Array.from(this.querySelectorAll('.db-faq__row'));
        if (rows.length < 2) return;
        rows.forEach((row, index) => {
          row.addEventListener('toggle', () => {
            if (!row.open) return;
            rows.forEach((other) => {
              if (other !== row && other.open) other.open = false;
            });
            this.track('faq_open', { question: index });
          });
        });
      }

      /* ---------------- Add to cart ---------------- */

      // Risolve quando db-exp-assign.liquid conclude la verifica "il carrello vince
      // sul cookie" (evento db-exp:resolved), o comunque entro ARM_RESOLUTION_TIMEOUT_MS
      // — quale delle due arriva prima. Se window.DbExp manca o è già risolto, risolve
      // subito: nessuna attesa quando non c'è nulla in sospeso.
      #waitForArmResolution() {
        const exp = window.DbExp;
        if (!exp || exp.resolved !== false) return Promise.resolve();
        return new Promise((resolve) => {
          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            document.removeEventListener('db-exp:resolved', onResolved);
            clearTimeout(timer);
            resolve();
          };
          const onResolved = () => finish();
          document.addEventListener('db-exp:resolved', onResolved, { once: true });
          const timer = setTimeout(finish, ARM_RESOLUTION_TIMEOUT_MS);
        });
      }

      async #addToCart(fromSticky = false) {
        // Bottone già disabilitato: due motivi legittimi, entrambi silenziosi qui.
        // (1) In CARICAMENTO — click doppio durante un invio in corso, non c'è nulla
        // di nuovo da comunicare. (2) Il braccio non ha nulla di selezionabile fin
        // dall'inizio (nessun radio checked, nessuna opzione disponibile):
        // #selectDefaultOption() lo scopre già in connectedCallback/al rebound e
        // disabilita il bottone lì (#updatePurchaseButtons(false), N3) — in un
        // browser vero un bottone genuinamente disabled non dispaccia nemmeno il
        // click, quindi questo ramo non ha nulla da mostrare: l'etichetta "Non
        // disponibile" ha già comunicato tutto prima ancora del click.
        //
        // L'argomento sopra vale solo per IL NODO che ha davvero dispacciato
        // il click. this.btn e this.stickyAtc sono due elementi DOM distinti:
        // #updatePurchaseButtons e #setLoading li tengono sincronizzati, ma
        // leggere lo stato dell'uno per decidere se fermare un click arrivato
        // dall'altro (N3-bis) smette di valere nel momento stesso in cui i
        // due dovessero disallinearsi — ed è già successo una volta, per un
        // motivo completamente diverso (l'ordine di risoluzione in
        // connectedCallback, vedi lì). fromSticky dice quale nodo ha generato
        // QUESTA chiamata: si controlla quello, non l'altro.
        const clickedBtn = fromSticky ? this.stickyAtc : this.btn;
        if (clickedBtn && clickedBtn.disabled) return;
        // this.selectedId può essere null anche a bottone ABILITATO — non più per il
        // caso "zero opzioni selezionabili fin dall'inizio" (quello ora lo cattura la
        // guardia sopra, grazie a N3), ma resta una difesa in profondità: se un
        // giorno una singola opzione risultasse disponibile ma con un
        // data-variant-id vuoto o malformato, #selectOption() abiliterebbe comunque
        // il bottone (dipende solo da opt.dataset.available) lasciando selectedId a
        // null. Uscire con un messaggio invece che nel nulla è la stessa forma del
        // difetto chiuso da 9c9ecf0 sul ricontrollo post-attesa, solo spostata sulla
        // guardia d'ingresso.
        if (!this.selectedId) {
          this.#status('Questa opzione non è più disponibile. Scegline un’altra.', 'error');
          return;
        }

        // Un ATC durante la finestra in cui il braccio è ancora provvisorio
        // rischierebbe un carrello misto: il click userebbe il braccio non ancora
        // confermato, e un rebound successivo lascerebbe nel carrello articoli di
        // due bracci — un ordine che sparisce da ogni metrica per braccio. Si
        // aspetta la conferma (riusando lo stato di loading esistente, non uno
        // nuovo) e SOLO DOPO si rilegge this.selectedId — mai prima: un rebound
        // nel frattempo lo aggiorna già da sé (vedi il listener in
        // connectedCallback), quindi si aggiunge sempre la variante che il
        // cliente vede al momento dell'aggiunta, mai una sostituita più tardi.
        const exp = window.DbExp;
        if (exp && exp.resolved === false) {
          this.#setLoading(true);
          await this.#waitForArmResolution();
          // NON ricontrollare this.btn.disabled qui: #setLoading(true) lo ha appena
          // impostato a true due righe sopra, e nulla lo rimette a false nel percorso
          // comune (nessun rebound) — quel controllo uscirebbe SEMPRE, silenziosamente,
          // tranne nel raro caso in cui un rebound avviene davvero (lì
          // #selectDefaultOption() lo riabilita come effetto collaterale). this.btn.disabled
          // è lo stato di CARICAMENTO, non di acquistabilità: this.selectedAvailable è il
          // segnale dedicato, aggiornato da #selectOption ad ogni selezione (inclusa
          // quella che un rebound può aver innescato nel frattempo).
          if (!this.selectedId || !this.selectedAvailable) {
            this.#setLoading(false);
            this.#status('Questa opzione non è più disponibile. Scegline un’altra.', 'error');
            return;
          }
        }

        const variantId = this.selectedId;
        this.track('atc_click', { variant_id: Number(variantId), source: fromSticky ? 'sticky' : 'main' });

        this.#setLoading(true);
        this.#status('', null);

        let CartLinesUpdateEvent = null;
        let deferred = null;
        try {
          const mod = await import('@shopify/events');
          if (mod && mod.CartLinesUpdateEvent) CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
        } catch (e) {
          CartLinesUpdateEvent = null;
        }

        if (CartLinesUpdateEvent) {
          try {
            deferred = CartLinesUpdateEvent.createPromise();
            this.dispatchEvent(
              new CartLinesUpdateEvent({
                action: 'add',
                context: 'product',
                lines: [{ merchandiseId: String(variantId), quantity: 1 }],
                promise: deferred.promise,
              })
            );
          } catch (e) {
            deferred = null;
          }
        }

        // Guardia esplicita, non un track() nudo nel catch: quel catch è
        // raggiungibile sia PRIMA che atc_result sia mai stato emesso (la
        // fetch stessa va in reject: offline, DNS, timeout) sia DOPO (qualcosa
        // più sotto lancia — trigger.click() poco più in basso è l'unico blocco
        // lì attorno senza un proprio try/catch). Senza la guardia, il secondo
        // caso produrrebbe un atc_result doppio, non uno mancante.
        let atcResultTracked = false;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          const data = await res.json().catch(() => ({}));
          this.track('atc_result', { ok: res.ok });
          atcResultTracked = true;

          if (!res.ok) {
            if (deferred) { try { deferred.reject(data); } catch (e) {} }
            this.#status(data.description || data.message || 'Impossibile aggiungere al carrello. Riprova.', 'error');
            return;
          }

          // Tagga il carrello col braccio. È la spina dorsale dell'attribuzione
          // insieme allo SKU: arriva nell'ordine come attributo e sopravvive ad
          // adblocker e rifiuto dei cookie di tracciamento. Non blocca l'acquisto.
          try {
            const exp = window.DbExp;
            if (exp && exp.status === 'running') {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  attributes: {
                    _exp_test: exp.testId,
                    _exp_arm: exp.arm,
                    _exp_uid: exp.uid,
                    _exp_sid: exp.sid
                  }
                })
              });
            }
          } catch (e) { /* l'acquisto procede comunque */ }

          // Aggiunge/riallinea i regali PRIMA di aprire il drawer, così appare già
          // completo. clearDeclined: una nuova scelta di bundle azzera i rifiuti
          // precedenti. Se il motore fallisce, l'acquisto procede comunque: la
          // protezione economica è degli sconti automatici lato server.
          try {
            await window.DermabellaGifts?.reconcile({ clearDeclined: true });
          } catch (e) { /* non bloccare l'acquisto */ }

          let nativeHandled = false;
          if (deferred && CartLinesUpdateEvent) {
            try {
              const ajaxCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                detail: {
                  items: ajaxCart.items,
                  source: 'dermabella-bundle-selector',
                  sourceId: this.dataset.sectionId || 'dermabella-bundle',
                  itemCount: 1,
                  didError: false,
                },
              });
              nativeHandled = true;
            } catch (e) {
              nativeHandled = false;
            }
          }

          if (!nativeHandled) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
            if (trigger) {
              trigger.click();
            } else {
              window.location.href = '/cart';
              return;
            }
          }

          // Apertura esplicita e idempotente del cart drawer: l'auto-open nativo
          // salta il PRIMISSIMO add di sessione (carrello vuoto, drawer mai aperto).
          try {
            const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer')
              || document.querySelector('theme-drawer[id*="cart" i], theme-drawer.cart-drawer');
            if (drawer && !drawer.hasAttribute('open') && typeof drawer.open === 'function') {
              drawer.open();
            }
          } catch (e) { /* non bloccare */ }
          // Qui, non prima: copre sia il path nativo (CartLinesUpdateEvent) sia il
          // fallback trigger.click() sia il backstop di questo blocco, qualunque
          // dei tre abbia davvero mostrato il drawer. Il ramo che naviga a /cart
          // esce con return più sopra e non arriva mai qui: lì non si apre nessun
          // drawer, cambia pagina.
          this.track('cart_open');

          this.#status('Aggiunto al carrello.', 'success');
        } catch (err) {
          if (!atcResultTracked) { this.track('atc_result', { ok: false }); atcResultTracked = true; }
          if (deferred) { try { deferred.reject(err); } catch (e) {} }
          this.#status('Connessione non riuscita. Riprova.', 'error');
        } finally {
          this.#setLoading(false);
        }
      }

      #setLoading(state) {
        // state=true (in caricamento): disabilita sempre. state=false (fine
        // richiesta): disabilita comunque se this.selectedAvailable è false — prima
        // riabilitava SEMPRE, rendendo impossibile la condizione che il commento
        // sotto descrive ("disabilitato solo se il bottone lo è"): un bottone
        // etichettato "Non disponibile" restava cliccabile, e un secondo click
        // produceva un atc_click per un acquisto che il server avrebbe rifiutato.
        //
        // Lo stesso valore vale per i due bottoni (dipende solo da state e
        // selectedAvailable, mai da un nodo specifico), ma va applicato a
        // CIASCUNO in modo indipendente — non rispecchiato dall'uno all'altro
        // dopo il fatto. Prima l'intero metodo usciva subito con
        // `if (!this.btn) return;`, quindi con this.btn assente lo sticky non
        // veniva mai disabilitato durante il caricamento: la stessa premessa
        // — un bottone che rappresenta lo stato di entrambi — che ha già
        // prodotto due difetti diversi su questo stesso percorso (N3-bis).
        const disabled = state || !this.selectedAvailable;
        if (this.btn) {
          this.btn.classList.toggle('is-loading', state);
          this.btn.disabled = disabled;
          this.btn.setAttribute('aria-busy', state ? 'true' : 'false');
        }
        if (this.stickyAtc) {
          this.stickyAtc.disabled = disabled;
        }
      }

      #status(message, state) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        if (state) {
          this.statusEl.dataset.state = state;
          this.statusEl.classList.remove('visually-hidden');
        } else {
          delete this.statusEl.dataset.state;
          this.statusEl.classList.add('visually-hidden');
        }
      }
    }

    customElements.define('dermabella-bundle-selector', DermabellaBundleSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermabella-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dermabella-sticky-atc')) {
    class DermabellaStickyAtc extends HTMLElement {
      /** @type {boolean} */
      #pastSentinel = false;

      /** @type {boolean} */
      #hiddenForFooter = false;

      /** @type {IntersectionObserver | null} */
      #sentinelObserver = null;

      /** @type {IntersectionObserver | null} */
      #footerObserver = null;

      connectedCallback() {
        const sentinel = this.querySelector('[data-sentinel]');
        const bar = this.querySelector('[data-bar]');
        if (!sentinel || !bar) return;

        this.sentinel = sentinel;
        this.bar = bar;

        this.#sentinelObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;
            this.#pastSentinel = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.#sync();
          },
          { threshold: 0 }
        );
        this.#sentinelObserver.observe(this.sentinel);

        const footer = document.querySelector('footer');
        if (footer) {
          this.#footerObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry) return;
              this.#hiddenForFooter = entry.isIntersecting;
              this.#sync();
            },
            { rootMargin: '0px 0px -1px 0px' }
          );
          this.#footerObserver.observe(footer);
        }
      }

      disconnectedCallback() {
        this.#sentinelObserver?.disconnect();
        this.#footerObserver?.disconnect();
      }

      #sync() {
        const visible = this.#pastSentinel && !this.#hiddenForFooter;
        this.bar.setAttribute('data-visible', visible ? 'true' : 'false');
      }
    }

    customElements.define('dermabella-sticky-atc', DermabellaStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
